import { WebGLRenderTarget, NearestFilter, RGBAFormat, HalfFloatType } from "three";
import Experience from "../Experience";

export default class Common {
    static _instance = null;

    static getInstance(){
        if(this._instance === null){
            this._instance = new Common();
        }
        return this._instance
    }

    constructor(){
        if(Common._instance){
            return Common._instance;
        }

        Common._instance = this;

        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.clock = this.experience.time
        // this.renderer = this.experience.renderer
        this.width = this.sizes.hero.width
        this.height = this.sizes.hero.height
        this.aspect = this.width / this.height;
        this.isMobile = false;
        this.breakpoint = 768;

        this.fboWidth = null;
        this.fboHeight = null;

        this.resizeFunc = this.resize.bind(this);

        this.time = 0;
        this.delta = 0;

        this.init()
    }

    init(){
        this.pixelRatio = window.devicePixelRatio;

        this.resize();

        this.renderer = this.experience.renderer.instance

        this.renderTarget = new WebGLRenderTarget(this.width, this.height, {
            minFilter: NearestFilter,
            magFilter: NearestFilter,
            format: RGBAFormat,
            type: HalfFloatType,
            stencilBuffer: false,
            depthBuffer: false,
            generateMipmaps: false
        });
     }

    resize(){
        this.width = this.sizes.hero.width;
        this.height = this.sizes.hero.height;
        this.aspect = this.width / this.height;
    }

    update(){
        this.delta = this.clock.getDelta(); // Math.min(0.01, this.clock.getDelta());
        this.time += this.delta;
    }

    getTexture() {
        return this.renderTarget.texture;
    }

    destroy() {
        window.removeEventListener('resize', this.resizeFunc);

        if (this.renderTarget) {
            this.renderTarget.dispose();
        }

        this.experience = null;
        this.sizes = null;
        this.clock = null;
        this.renderer = null;

        this.width = null;
        this.height = null;
        this.aspect = null;
        this.isMobile = false;
        this.fboWidth = null;
        this.fboHeight = null;
        this.pixelRatio = null;
        this.time = 0;
        this.delta = 0;

        Common._instance = null;
    }
}
